module.exports = __webpack_public_path__ + "static/media/icon_saoraodianhuajubao.f11f7fe7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/icon_saoraodianhuajubao.svg
// module id = 225
// module chunks = 0